export const PHONE_ERROR = 'Неправильный формат телефона';
export const PHONE_MASK = '+7\\ (999) 999-99-99';
export const AUTO_MASK_LENGTH = 4;
